import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowSmRightIcon } from '@heroicons/react/outline';

import { useChain } from 'contexts';

type Props = {
  actionTo: string;
  actionTitle: string;
  isThemed?: boolean;
  styleSlug?: string;
};

const ActionToButton: React.FC<Props> = ({
  actionTo,
  actionTitle,
  isThemed = true,
  styleSlug: propStyleSlug,
}) => {
  const { styleSlug: backupStyleSlug } = useChain();
  const styleSlug = propStyleSlug || backupStyleSlug;

  const colorClassName = isThemed
    ? `bg-${styleSlug}-dark text-white dark:bg-${styleSlug}-light dark:text-${styleSlug}-dark`
    : 'bg-sand-light dark:bg-gray-222 text-sand-dark dark:text-gray-ccc';
  const className = `${colorClassName} inline-flex items-center rounded-full py-1 pl-5 md:pl-5 pr-3 md:pr-4 uppercase text-center text-xs md:text-xs`;

  const arrowColorClassName = isThemed
    ? `text-${styleSlug}-light dark:text-${styleSlug}-dark`
    : 'text-gray-444 dark:text-gray-ccc';
  const children = (
    <>
      {actionTitle}&nbsp;&nbsp;
      <ArrowSmRightIcon className={`${arrowColorClassName} w-5 h-5 -mt-0.5`} />
    </>
  );

  return actionTo.startsWith('http') ? (
    <a target="_blank" rel="noreferrer" href={actionTo} className={className}>
      {children}
    </a>
  ) : (
    <Link to={actionTo} className={className}>
      {children}
    </Link>
  );
};

export default ActionToButton;
